import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { viewBox: "0 0 381.36 461.34" }

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", { d: "M325.18 360.6v44.14h-57.02V137.57h21.96V81.18H189.59v56.39h20.91v180.97h-8.19L137.65 0H81.09L19.75 318.54H0v55.52h91.07v-55.52H77.35l7.28-41.79h53.02l7.28 41.79h-12.89v55.52h78.47v30.89H189.6v56.39h191.77V360.6h-56.18ZM93.98 223.52l17.05-98.14 17.26 98.14H93.98Z" }, null, -1)
  ])))
}
export default { render: render }